/**
 * UnifiedMediaSection constants.
 * Centralizes timing and regex values used across section modules.
 */

/** Minimum ms to keep section skeleton visible before reveal. */
export const FW_PLAYER_SKELETON_MIN_MS = 800;

/** Max ms to wait for fw:player:ready before fallback reveal. */
export const FW_PLAYER_READY_MAX_WAIT_MS = 800;

/** Matches playlist paging URLs like /playlists/:id/videos. */
export const PLAYLIST_VIDEOS_PATH_RE = /\/playlists\/([^/]+)\/videos/;

/** Key used for server-provided "all tab" datasets. */
export const ALL_TAB_SERVER_KEY = "__ALL__";
